export const SQUIZ_DXP_HOST = 'https://dxp-uk-search.funnelback.squiz.cloud';
export const FUNNELBACK_SEARCH_ENDPOINT = `${SQUIZ_DXP_HOST}/s/search.json`;
export const FUNNELBACK_AUTO_SUGGEST_ENDPOINT = `${SQUIZ_DXP_HOST}/s/suggest.json`;
export const SEARCH_PATH = '/search';
export const INTERNAL_SEARCH_ENDPOINT = '/api/search';

export const ALL = 'all';
export const ADVICE = 'advice';
export const POLICY = 'policy library';
export const LEGAL = 'legal';

export const COLLECTIONS = {
  england: `shelter~sp-contentful_england`,
  scotland: `shelter~sp-contentful_scotland`,
};

export const filterOptions = [ALL, ADVICE, POLICY, LEGAL];

const labels = {
  scotland: {
    [ALL]: 'All',
    [ADVICE]: 'Advice',
    [POLICY]: 'Policy',
    [LEGAL]: 'Legal',
  },
  england: {
    [ALL]: 'All results',
    [ADVICE]: 'Housing advice',
    [POLICY]: 'Policy library',
    [LEGAL]: 'Legal guidance for professionals',
  },
};

export const filterLabels = labels[process.env.SHELTER_SITE];
